import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/about')({
  component: AboutPage,
});

function AboutPage() {
  return (
    <main className="container-page py-20">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-serif text-warm-900 mb-8">About Kamalkari</h1>

        <div className="prose prose-warm max-w-none">
          <p className="text-lg text-warm-700 mb-6">
            Kamalkari brings the timeless beauty of Kalamkari art to modern homes. Our collection
            features handcrafted pieces created by skilled artisans using techniques passed down
            through generations.
          </p>

          <h2 className="text-2xl font-serif text-warm-800 mt-12 mb-4">Our Story</h2>
          <p className="text-warm-600 mb-4">
            Kalamkari, derived from the Persian words "kalam" (pen) and "kari" (craftsmanship),
            is an ancient art form that originated in India over 3,000 years ago. This intricate
            hand-painting technique uses natural dyes extracted from plants and minerals.
          </p>

          <h2 className="text-2xl font-serif text-warm-800 mt-12 mb-4">Our Commitment</h2>
          {/* <ul className="space-y-2 text-warm-600">
            <li>100% handcrafted using traditional techniques</li>
            <li>Natural, eco-friendly dyes</li>
            <li>Fair trade partnerships with artisan communities</li>
            <li>Sustainable packaging and shipping practices</li>
          </ul> */}

          <h2 className="text-2xl font-serif text-warm-800 mt-12 mb-4">Contact Us</h2>
          <p className="text-warm-600">
            Have questions? We'd love to hear from you. Reach out to us at{' '}
            <a href="mailto:inquiries@livaiton.com" className="text-warm-800 underline">
              inquiries@livaiton.com
            </a>
          </p>
        </div>
      </div>
    </main>
  );
}
